<template>
    <v-layout row>
        <v-flex xs12>
            <v-scroll-y-transition mode="out-in">
                <v-card v-if="!checkRuap && payActivate == false">
                    <v-card-title primary-title class="grey lighten-4">
                        <v-tooltip top>
                            <v-btn slot="activator" dark @click.stop="dialogo = true" icon class="mx-0">
                                <v-icon color="red">help</v-icon>
                            </v-btn>
                            <span>Registro de la Actuación Profesional</span>
                        </v-tooltip>
                        <h3 class="headline mb-0">Lista de Actuaciones</h3>
                        <v-btn
                         @click="refresh"
                          round
                          :to="{ name: 'ruap-pre-aprobado' }"
                          color="blue"
                          class="white--text"
                        >
                          pre aprobadas
                          <v-icon right dark>cached</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-dialog v-model="dialog" max-width="800px" persistent>
                            <!-- <template v-slot:activator="{ on }">
                                <v-btn color="primary" dark class="mb-2" v-on="on">Agregar Actuación</v-btn>
                            </template> -->
                            <v-card>
                                <v-form ref="formnewruap" v-model="valid" lazy-validation>
                                    <v-card-title>
                                        <span class="headline">Actuación Profesional</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container grid-list-md>
                                        <v-layout wrap>
                                            <v-flex xs12 v-if="user.length != 0" align-center justify-center layout text-xs-center>
                                                <v-avatar tile v-if="user.user.foto != null" size="100">
                                                    <v-img :src="`/${user.user.foto}`" class="mb-4"></v-img>
                                                </v-avatar>
                                            </v-flex>
                                            <v-flex xs12 v-if="user.length != 0" align-center justify-center layout text-xs-center>
                                                <h3 class="headline mb-2">{{ user.user.name }} </h3>
                                            </v-flex>
                                            <v-flex xs12 sm4>
                                                <v-text-field
                                                    disabled
                                                    ref="cpc"
                                                    v-model="form.cpc"
                                                    prepend-icon="credit_card"
                                                    :append-outer-icon="user.exist && user.solvencia[0].solvente ? 'done' : 'clear'"
                                                    :color="user.exist ? user.exist && user.solvencia[0].solvente ? 'green' : 'red' : 'red'"
                                                    :error-messages="errorMessageExistsCpc"
                                                    label="CPC"
                                                    :rules="[v => !!v || 'CPC es requerido']"
                                                    @change="validCpcRuap"
                                                    required
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm4>
                                                <v-text-field
                                                    disabled
                                                    v-model="form.document_requiremets"
                                                    prepend-icon="find_in_page"
                                                    label="Tipo de Actuación"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm4>
                                                <v-text-field
                                                    disabled
                                                    v-model="form.document_types"
                                                    prepend-icon="find_in_page"
                                                    label="Tipo de Documento"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm6>
                                                <v-text-field
                                                    disabled
                                                    v-model="form.number_id"
                                                    prepend-icon="subtitles"
                                                    label="Rif del cliente"
                                                    :rules="[v => !!v || 'Rif es requerido']"
                                                    mask="A-########-#"
                                                    required
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm6>
                                                <v-text-field
                                                    :disabled="tipo === 'ver'"
                                                    v-model="form.client"
                                                    prepend-icon="domain"
                                                    label="Razon social del Cliente"
                                                    :rules="[v => !!v || 'Cliente es requerido']"
                                                    required
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm4>
                                                <v-text-field
                                                    :disabled="tipo === 'ver'"
                                                    v-model="form.pages"
                                                    prepend-icon="view_carousel"
                                                    label="Num Paginas"
                                                    :rules="[v => !!v || 'Num Paginas es requerido']"
                                                    required
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm4>
                                                <v-menu
                                                    :disabled="tipo === 'ver'"
                                                    ref="menu"
                                                    lazy
                                                    :close-on-content-click="false"
                                                    v-model="menu"
                                                    transition="scale-transition"
                                                    offset-y
                                                    full-width
                                                    :nudge-right="40"
                                                    min-width="290px"
                                                    :return-value.sync="fecha"
                                                >
                                                    <v-text-field
                                                        :disabled="tipo === 'ver'"
                                                        slot="activator"
                                                        label="Fecha"
                                                        v-model="computedDateFormattedFecha"
                                                        hint="DD/MM/YYYY formato"
                                                        prepend-icon="event"
                                                        :rules="[v => !!v || 'Fecha es requerido']"
                                                        required
                                                        readonly
                                                    ></v-text-field>
                                                    <v-date-picker v-model="form.date" no-title scrollable>
                                                    <v-spacer></v-spacer>
                                                    <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                                                    <v-btn flat color="primary" @click="$refs.menu.save(fecha)">OK</v-btn>
                                                    </v-date-picker>
                                                </v-menu>
                                            </v-flex>
                                            <v-flex xs12 sm4>
                                                <v-text-field
                                                    :disabled="tipo === 'ver'"
                                                    prepend-icon="credit_card"
                                                    v-model="form.amount"
                                                    label="Monto Actuación"
                                                    :rules="[v => !!v || 'Monto Actuación es requerido']"
                                                    required
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm4>
                                                <v-text-field
                                                    :disabled="tipo === 'ver'"
                                                    prepend-icon="credit_card"
                                                    :value="document_price"
                                                    label="Precio del Documento"
                                                    readonly
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm4>
                                                <v-text-field
                                                    :disabled="tipo === 'ver'"
                                                    prepend-icon="credit_card"
                                                    value="1200"
                                                    label="Monto Gestión Gremial"
                                                    readonly
                                                ></v-text-field>
                                            </v-flex>
                                            <!-- seleccion del tipo de hoja -->
                                            <v-flex xs12 pb-0 pt-0>
                                                <v-radio-group :disabled="tipo === 'ver'" v-model="form.tipo_hoja" row :rules="[v => !!v || 'Tipo de papel es requerido']">
                                                    <template v-slot:label>
                                                        <div><strong>Tipo de hojas:</strong></div>
                                                    </template>
                                                    <v-radio color="primary" value="sistema">
                                                        <template v-slot:label>
                                                        <div><strong>Por Sistema</strong></div>
                                                        </template>
                                                    </v-radio>
                                                    <v-radio color="primary" value="propia">
                                                        <template v-slot:label>
                                                        <div><strong>Hojas de Seguridad</strong></div>
                                                        </template>
                                                    </v-radio>
                                                </v-radio-group>
                                            </v-flex>
                                            <!-- hojas (desde hasta) - de tener hojas de seguridad -->
                                            <v-flex v-show="form.tipo_hoja == 'propia'" xs12 pt-0 pb-0>
                                                <v-subheader style="height: 20px" class="pa-0 mt-0">Escriba el Número de hoja seguido de la tecla enter</v-subheader>
                                                <v-combobox
                                                    :disabled="tipo === 'ver'"
                                                    v-model="form.security_papers"
                                                    label="Número de hojas a utilizar"
                                                    chips
                                                    clearable
                                                    solo
                                                    multiple
                                                >
                                                    <template v-slot:selection="data">
                                                        <v-chip
                                                            :selected="data.selected"
                                                            close
                                                            @input="remove(data.item)"
                                                        >
                                                            <strong>{{ data.item }}</strong>&nbsp;
                                                        </v-chip>
                                                    </template>
                                                </v-combobox>
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-textarea
                                                    :disabled="tipo === 'ver'"
                                                    v-model="form.subject"
                                                    prepend-icon="featured_play_list"
                                                    label="Finalidad"
                                                    auto-grow
                                                    :rules="[v => !!v || 'Finalidad es requerido']"
                                                    required
                                                    box
                                                    rows="1"
                                                ></v-textarea>
                                            </v-flex>

                                        </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions v-if="tipo != 'ver'">
                                        <v-btn color="blue darken-1" flat @click="closeRegisterSat">Olvidar</v-btn>
                                        <v-spacer></v-spacer>
                                        <v-btn v-if="editedIndex == -1" :loading="loading" color="primary darken-1" @click="submitForm">Crear</v-btn>
                                        <v-btn v-if="editedIndex > -1" :loading="loading" color="primary darken-1" @click="submitFormUpdate">Actualizar</v-btn>
                                    </v-card-actions>
                                    <v-card-actions v-if="tipo === 'ver'">
                                        <v-btn color="blue darken-1" flat @click="closeRegisterSat">Cerrar</v-btn>
                                        <v-spacer></v-spacer>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-card-title>
                    <v-card-title primary-title class="grey lighten-4">
                        <v-spacer></v-spacer>
                        <v-text-field
                            @change="onChange"
                            slot="input"
                            v-model="search"
                            append-icon="search"
                            label="Buscar CPC"
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <div>
                            <v-data-table
                                :loading="loading"
                                :headers="headers"
                                :items="sat"
                                rows-per-page-text="Filas por Página"
                                :pagination.sync="pagination"
                                :rows-per-page-items="rowsPerPageItems"
                                :total-items="total"
                                row
                                wrap
                                class="elevation-0"
                            >
                                <template v-slot:items="props">
                                    <!-- <td>
                                        <v-avatar size="36px">
                                            <img v-if="props.item.user_foto" :src="`/${props.item.user_foto}`" :alt="props.item.user_name">
                                            <v-icon v-else color="primary">person</v-icon>
                                        </v-avatar>
                                    </td> -->
                                    <td>{{ props.item.cpc }} - {{ props.item.user_name }}</td>
                                    <td class="text-xs-left">{{ props.item.document_types }}</td>
                                    <td class="text-xs-left">{{ props.item.number_id }} - {{ props.item.client }}</td>
                                    <td class="text-xs-left">{{ props.item.revisor ?  props.item.revisor : 'N/A' }}</td>
                                    <td class="text-xs-center">{{ props.item.digital ?  'DIG' : 'IMP' }}</td>
                                    <td class="text-xs-center">{{ props.item.pages }}</td>
                                    <td class="text-xs-center">{{  Number(props.item.amount).toLocaleString('es-VE', {style:'currency', currency:'BSS'}) }}</td>
                                    <td class="text-xs-center">{{  props.item.invoice_id ?  props.item.invoice_id : '' }}</td>
                                    <td class="text-xs-center">{{  props.item.security ? props.item.security : 'Sin Asignar' }}</td>
                                    <td class="text-xs-center">{{  props.item.created_at }}</td>
                                    <td class="justify-center layout px-0">
                                    <!-- <v-tooltip top>
                                        <v-btn @click="printFactura(props.item.id)" :disabled="!props.item.agreement" slot="activator" icon class="mx-0" >
                                            <v-icon color="primary">print</v-icon>
                                        </v-btn>
                                        <span>Imprimir Factura</span>
                                    </v-tooltip> -->
                                    <!-- <v-tooltip top>
                                        <v-btn @click="efectuarPago(props)" :disabled="props.item.service_payments.length > 0 ? props.item.service_payments[0].invoice.agreement : false" slot="activator" icon class="mx-0" >
                                            <v-icon color="primary">account_balance_wallet</v-icon>
                                        </v-btn>
                                        <span>Efectuar Pago</span>
                                    </v-tooltip> -->
                                    <v-tooltip top>
                                        <v-btn @click="checkSat(props)" slot="activator" icon class="mx-0" >
                                            <v-icon color="primary">find_in_page</v-icon>
                                        </v-btn>
                                    <span>Revisión RAP</span>
                                    </v-tooltip>
                                    <!-- <v-tooltip top>
                                        <v-btn :disabled="props.item.agreement" @click="editItem(props.item, 'editar')" slot="activator" icon class="mx-0" >
                                            <v-icon color="blue">edit</v-icon>
                                        </v-btn>
                                        <span>Editar RAP</span>
                                    </v-tooltip> -->
                                    <!-- <v-tooltip top>
                                        <v-btn @click="editItem(props.item, 'ver')" slot="activator" icon class="mx-0" >
                                            <v-icon color="blue">description</v-icon>
                                        </v-btn>
                                        <span>Ver RAP</span>
                                    </v-tooltip> -->
                                    <v-tooltip top>
                                        <v-btn @click="deleteItem(props.item)" slot="activator" icon class="mx-0" >
                                            <v-icon color="red">delete</v-icon>
                                        </v-btn>
                                        <span>Eliminar RAP</span>
                                    </v-tooltip>
                                    </td>
                                </template>
                            </v-data-table>
                        </div>
                    </v-card-text>
                </v-card>
            </v-scroll-y-transition>
            <v-scroll-y-transition mode="out-in">
                <RuapValidate :statusBtn="statusBtn" :loading="loading" v-on:loading="loading = $event" v-on:backevent="checkRuap = $event" v-if="checkRuap && payActivate == false" :requirements="documentsRequirementsSat" :devolutions="devolutions_list"/>
            </v-scroll-y-transition>
            <v-scroll-y-transition mode="out-in">
                <PagosRuap :information="information" v-if="payActivate" @close-loading="closeLoading" @close-pay="closePay"/>
            </v-scroll-y-transition>
        </v-flex>

        <v-dialog
            v-model="loading"
            hide-overlay
            persistent
            width="300"
        >
            <v-card
                color="primary"
                dark
            >
                <v-card-text>
                Porfavor Espere...
                <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-layout row justify-center>
            <v-dialog v-model="print" persistent max-width="800px">
                <v-card>
                    <v-card-title>
                        <span class="headline">Factura</span>
                    </v-card-title>
                    <v-card-text>
                        <FacturaPago :data="dataFactura" v-if="print"/>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary darken-1" @click="closePay">Cerrar</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn :loading="loading" color="primary darken-1" flat v-print="'#printMe'">Imprimir Factura</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

        <v-dialog v-model="dialogPagoCliente" width="600" persistent>
            <v-flex xs12>
                <v-card>
                <v-form ref="formpago" v-model="validpago" lazy-validation v-if="dialogPagoCliente">
                    <v-card-title>
                        <h3 class="headline mb-0"><span style="color: #9C1A1A">Pago del Agremiado</span></h3>
                    </v-card-title>
                    <v-card-text>
                        <v-flex xs12 align-center justify-space-between>
                            <v-layout align-center>
                                <v-flex xs12 sm4>
                                    <v-text-field
                                        ref="rif"
                                        v-model="information.rif"
                                        prepend-icon="featured_video"
                                        label="RIF"
                                        readonly
                                        mask="A-########-#"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm8>
                                    <v-text-field
                                        ref="razonsocial"
                                        v-model="information.razon_social"
                                        prepend-icon="person"
                                        label="Razon social"
                                        readonly
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12>
                            <v-text-field
                                ref="direccionfiscal"
                                v-model="information.direccion_fiscal"
                                prepend-icon="domain"
                                label="Direccion Fiscal"
                                readonly
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs12 align-center justify-space-between>
                            <v-layout align-center>
                                <v-flex xs12 sm6>
                                    <v-select
                                        prepend-icon="account_balance_wallet"
                                        :items="wayToPay"
                                        v-model="information.payments[0].way_to_pay"
                                        label="Método de pago"
                                        readonly
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                        ref="amount"
                                        v-model="information.payments[0].amount"
                                        prepend-icon="scatter_plot"
                                        label="Monto a pagar"
                                        readonly
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12>
                            <v-select
                                v-if="information.payments[0].way_to_pay == 'PUNTO ELECTRONICO' || information.payments[0].way_to_pay == 'TRANSFERENCIA'"
                                prepend-icon="account_balance"
                                :items="banks"
                                v-model="information.payments[0].bank_id"
                                item-text="name"
                                item-value="id"
                                label="Banco"
                                readonly
                            ></v-select>
                        </v-flex>

                        <v-flex xs12 align-center justify-space-between>
                            <v-layout align-center>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                        v-if="information.payments[0].way_to_pay == 'PUNTO ELECTRONICO' || information.payments[0].way_to_pay == 'TRANSFERENCIA'"
                                        ref="number"
                                        v-model="information.payments[0].number"
                                        prepend-icon="remove"
                                        label="Número de transacción"
                                        readonly
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                        label="Fecha"
                                        v-model="computedDateFormattedFecha3"
                                        prepend-icon="event"
                                        readonly
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12>
                            <v-textarea
                                readonly
                                prepend-icon="reorder"
                                v-model="information.payments[0].observations"
                                auto-grow
                                color="primary"
                                label="Observación"
                                rows="2"
                            ></v-textarea>
                        </v-flex>

                        <!--<v-flex xs12>
                            <input hidden type="file" ref="fileInput" @change="processFile($event)">
                            <v-text-field
                                ref="document"
                                v-model="form.document"
                                @click.native="onFocus"
                                prepend-icon="attach_file"
                                label="Imagen del pago"
                            ></v-text-field>
                        </v-flex> -->

                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary darken-1" @click="closePay">Cerrar</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
                </v-form>
            </v-card>
        </v-flex>
        </v-dialog>
        <!-- Inicio de dialogo -->
    <v-dialog
          v-model="dialogo"
          max-width="700"
        >
          <v-card>
            <v-card-title class="headline">ACTUACIONES PRE APROBADAS - RAPE</v-card-title>

            <v-card-text>
              <p>Lista de actualiciones revisadas satisfactoriamente y en espera de que el agremiado registre el pago para su aprobación definitiva.</p>
              <h3>Opciones</h3>
              <ul>
                <li>Visualizar todas las actuaciones PRE-APROBADAS.</li>
                <li>Revisar Actuación Profesional.</li>
                <li>Editar Actuación Profesional.</li>
                <li>Eliminar Actuación Profesional.</li>
              </ul>
              <br>
              <p>Una vez conciliado el pago, los registros cambian su estatus a APROBADA y desaparecen de esta lista.</p>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="green darken-1"
                flat="flat"
                @click="dialogo = false"
              >
                Salir
              </v-btn>

            </v-card-actions>
      </v-card>
    </v-dialog>
<!-- Fin de dialogo -->

  </v-layout>
</template>

<script>
import moment from 'moment';
import Form from 'vform'
import axios from 'axios'
import { mapGetters } from 'vuex'
import RuapValidate from '~/pages/ruap/RuapValidate.vue'
import PagosRuap from '~/components/pagos/pay.vue'
import FacturaPago from '~/components/factura/FacturaPago.vue'

export default {

    name: "sat-view",

    components: {
        RuapValidate,
        FacturaPago,
        PagosRuap
    },

    computed: {
        ...mapGetters({
            documentsRequirementsSat: 'getDocumentRequirementSat',
            documentsRequirementsChildSat: 'getSatDocumentsTypeChild',
            documentsType: 'getSatDocumentsType',
            banks: 'getSatBanks',
            user: 'getSatStatusUser',
            received: 'getSatRuapReceived',
            document_price: 'getSatDocumentPrice',
            devolutions_list: 'getSatDevolutionsList',
            electronic_points: 'getSatElectronicPoints',
            print: 'printFacturaPay',
            dataFactura: 'dataFacturaPay'
        }),
        computedDateFormattedFecha () {
            return this.formatDate(this.form.date)
        },
        computedDateFormattedFecha2 () {
            return this.formatDate(this.formConciliacion.payment_date)
        },
        computedDateFormattedFecha3 () {
            return this.formatDate(this.information.payments[0].payment_date)
        },
        errorMessageExistsCpc () {
            if (this.user.length !== 0) {
                if (this.user.exist) {
                    if (!this.user.solvencia[0].solvente) {
                        return `Saldo Deudor: ${this.user.saldo_deudor}`
                    }
                }else{
                    return 'CPC no existe'
                }
            }

            return ''
        }
    },

    data () {
      return {
        statusBtn: '',
        tipo: '',
        firstLetter: '',
        itemChildDocument: [],
        fecha: null,
        menu: false,
        fecha2: null,
        menu2: false,
        date3: null,
        fecha3: null,
        menu3: false,
        sat: [],
        information: {},
        search: '',
        total: 0,
        valid: false,
        validpago: false,
        validConciliacion: false,
        dialog: false,
        dialogo: false,
        dialogPagoCliente: false,
        loading: false,
        checkRuap: false,
        payActivate: false,
        dialogConsolidacion: false,
        editedIndex: -1,
        pagination: {},
        wayToPay: ['TRANSFERENCIA'],
        headers: [
            { text: 'CPC',            align: 'left',      value: 'cpc',     sortable: false },
            { text: 'Tipo Documento', align: 'left',      value: 'document_types',      sortable: false },
            { text: 'Cliente',        align: 'left',      value: 'rif-client',           sortable: false },
            { text: 'Revisor',        align: 'left',      value: 'user_name',       sortable: false },
            { text: 'Papel',          align: 'center',    value: 'papeltipo',     sortable: false },
            { text: 'Paginas',        align: 'center',    value: 'pages',       sortable: false },
            { text: 'Monto',          align: 'center',    value: 'amount',        sortable: false },
            { text: 'Registro',        align: 'center',    value: 'invoice_id',    sortable: false },
            { text: 'Seguridad',      align: 'left',      value: 'security',      sortable: false },
            { text: 'Registrado',     align: 'center',    value: 'created_at',    sortable: true },
            { text: 'Actions', align: 'center', value: 'name', sortable: false }
        ],
        rowsPerPageItems: [10, 20, 50, 100],
        form: new Form({
            cpc: '',
            document_type_father: '',
            document_type: '',
            client: '',
            number_id: '',
            subject: '',
            date: '',
            pages: '',
            tipo_hoja: '',
            tipo_persona: '',
            security_papers: null,
            amount: ''
        })
      }
    },

    watch: {

        pagination() {
            this.getSatByPagination();
        },

        received(v) {
            if (v.length !== 0) {
                this.search = v.data[0].client;
                this.sat = v.data;
                this.total = v.total;
            }
        }

    },

    mounted () {
        this.$store.dispatch('clearMessage')
        this.$store.dispatch('fetchSatDocumentsType')
    },

    methods: {

        dateDiff (props) {
            if (props.item.updated_at == null) {
                return ''
            } else {
                let a = moment(props.item.created_at)
                let b = moment(props.item.updated_at)
                var diff = moment.duration(moment(b).diff(moment(a)));

                return parseInt(diff.asDays()) + ' dias ' + moment.utc(moment(props.item.updated_at, "YYYY/MM/DD HH:mm:ss").diff(moment(props.item.created_at, "YYYY/MM/DD HH:mm:ss"))).format("HH:mm:ss")
            }
        },

        tipoPersona () {
            if(this.form.number_id == ''){
                this.form.number_id = this.firstLetter
            }
            if(this.form.number_id.charAt(0) == 'V' || this.form.number_id.charAt(0) == 'P' || this.form.number_id.charAt(0) == 'J' || this.form.number_id.charAt(0) == 'G'){
                this.form.tipo_persona = (this.form.number_id.charAt(0) == 'V' || this.form.number_id.charAt(0) == 'P') ? 'NATURAL' : 'JURIDICA'
            }else {
                this.form.number_id = this.firstLetter
            }
        },

        getSatByPagination() {
            this.loading = true;
            if (this.search && !this.pagination.sortBy) {
                axios.get(`/api/sat/pre-aprobado-filter?query=${this.search}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                    .then(res => {
                        this.sat = res.data.data;
                        this.total = res.data.total;
                    })
                    .finally(() => this.loading = false);
            }
            if (this.pagination.sortBy && this.search) {
                const direction = this.pagination.descending ? 'desc' : 'asc';
                axios.get(`/api/sat/pre-aprobado-filter-order?query=${this.search}&direction=${direction}&sortBy=${this.pagination.sortBy}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                    .then(res => {
                        this.sat = res.data.data;
                        this.total = res.data.total;
                    })
                    .finally(() => this.loading = false);
            }
            if (this.pagination.sortBy && !this.search) {
                const direction = this.pagination.descending ? 'desc' : 'asc';
                axios.get(`/api/sat/pre-aprobado-order?direction=${direction}&sortBy=${this.pagination.sortBy}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                    .then(res => {
                        this.loading = false;
                        this.sat = res.data.data;
                        this.total = res.data.total;
                    })
                    .finally(() => this.loading = false);
            }
            if(!this.search && !this.pagination.sortBy) {
                axios.get(`/api/sat/pre-aprobado?page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                    .then(res => {
                        // console.log(res.data)
                        this.sat = res.data.data;
                        this.total = res.data.total;
                    })
                    .finally(() => this.loading = false);
            }
        },

        editItem (item, tipo) {
            this.tipo = tipo
            this.editedIndex = this.sat.indexOf(item)
            this.form = Object.assign({}, item)
            this.firstLetter = this.form.number_id.charAt(0)
            this.tipoPersona()
            /* if(item.document_requiremets.length != 0){
                this.form.document_requiremets = item.document_requiremets[0].document_data.category
            } */
            this.getPriceDocument()
            if(item.security_papers == "null" || item.security_papers == null){
                this.form.tipo_hoja = "sistema"
                this.form.security_papers = null
            }else{
                this.form.tipo_hoja = "propia"
            }
            this.dialog = true
        },

        async deleteItem (item) {
            let response = confirm('Estas seguro de eliminar este RAP?')
            if(response){
                this.loading = true
                await this.$store.dispatch('deleteRap', {id: item.id, status: 'PRE APROBADO'})
                this.$nextTick(() => {
                    this.loading = false
                })
            }
        },

        onChange () {
            this.getSatByPagination();
        },

        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },

        async validCpcRuap() {
            this.loading = true;
            await this.$store.dispatch('validCpcRuap', this.form.cpc)
            this.$nextTick(() => {
                this.loading = false
            })
        },

        async getPriceDocument() {
            this.loading = true;
            // await this.$store.dispatch('fetchPriceDocument', this.form.document_type)
            console.log(this.form)
            await this.$store.dispatch('fetchPriceDocument', { document_type: this.form.concept_document_type_id, personalidad: this.form.tipo_persona })
            this.$nextTick(() => {
                this.loading = false
            })
        },

        async getChildDocument() {
            this.loading = true;
            this.itemChildDocument = this.documentsRequirementsChildSat.filter(drcs => { return drcs.padre_document_type_id == this.form.document_type_father })
            // await this.$store.dispatch('fetchChildDocument', this.form.document_type_father)
            this.$nextTick(() => {
                this.loading = false
            })
        },

        async submitForm() {
            if (this.$refs.formnewruap.validate()) {
                this.loading = true
                await this.$store.dispatch('submitNewRuap', this.form)
                this.$nextTick(() => {
                    this.dialog = false
                    this.loading = false
                    this.form = {
                        cpc: '',
                        document_type_father: '',
                        document_type: '',
                        client: '',
                        number_id: '',
                        subject: '',
                        date: '',
                        pages: '',
                        tipo_hoja: '',
                        tipo_persona: '',
                        security_papers: null,
                        amount: ''
                    }
                    this.$refs.formnewruap.resetValidation()
                })
            }
        },

        preAprobado(){
          let a = 'Listar las actuaciones preAprobado';
          window.alert(a)
        },

        refresh(){
          location.reload(true);
        },

        async submitFormUpdate() {
            if (this.$refs.formnewruap.validate()) {
                this.loading = true
                await this.$store.dispatch('submitUpdateRuap', this.form)
                this.$nextTick(() => {
                    this.dialog = false
                    this.loading = false
                    this.form = {
                        cpc: '',
                        document_type_father: '',
                        document_type: '',
                        client: '',
                        number_id: '',
                        subject: '',
                        date: '',
                        pages: '',
                        tipo_hoja: '',
                        tipo_persona: '',
                        security_papers: null,
                        amount: ''
                    }
                    this.$refs.formnewruap.resetValidation()
                })
            }
        },

        async closeRegisterSat() {
            this.dialog = false
            this.form = {
                cpc: '',
                document_type_father: '',
                document_type: '',
                client: '',
                number_id: '',
                subject: '',
                date: '',
                pages: '',
                tipo_hoja: '',
                tipo_persona: '',
                security_papers: null,
                amount: ''
            }
            this.loading = false
            this.$refs.formnewruap.resetValidation()
        },

        async checkSat (props) {
            if(props.item.condition == 'ACTIVO'){
                this.loading = true
                this.checkRuap = true
                this.statusBtn = props.item.service_status
                // this.statusRap = props.item.status
                console.log(props.item.service_status)
                await this.$store.dispatch('searchDocumentRuapRequirement', props.item.id)
                this.$nextTick(() => {
                    this.loading = false
                })
            }else {
                await this.$store.dispatch('responseMessage', {
                    type: 'error',
                    text: 'Verificar procedencia del agremiado'
                })
            }
        },

        async efectuarPago(props) {

            if(props.item.service_payments.length > 0){
                if(props.item.service_payments[0].invoice != null){
                    if(props.item.service_payments[0].invoice.payments.length > 0){
                        this.information = props.item.service_payments[0].invoice
                        this.dialogPagoCliente = true
                    }else {
                        this.information = props.item
                        this.loading = true;
                        this.payActivate = true
                    }
                }else {
                    this.information = props.item
                    this.loading = true;
                    this.payActivate = true
                }
            }else {
                this.information = props.item
                this.loading = true;
                this.payActivate = true
            }
        },

        async closeLoading() {
            this.loading = false;
        },

        async closePay() {
            this.loading = false;
            this.payActivate = false
            if(this.dialogPagoCliente) {
                this.dialogPagoCliente = false
            }else {
                await this.$store.dispatch('setModalFacturaPay', false)
            }
            this.information = {}
        },

        async printFactura(id) {
            this.loading = true
            await this.$store.dispatch('generarPrintFactura', id)
            this.$nextTick(() => {
                this.loading = false
            })
        }

    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/ruap/RuapListVisadoPreAprobado.vue